import { ViewModelPathUtil } from "@/components/features/_model/converter/input-model-to-view-model/mapper/util";
import type { AutoGeneratorForFormModel } from "@/components/features/_model/types";

import * as Composition from "./composition";

/**
 *
 * @description InputModel と ZodSchema を元に validation を行い、エラーがあれば ViewModel にマージする
 *
 * @param viewModel
 * @param excludeKeys
 * @param inputModel
 * @param zodSchema
 *
 * @returns ViewModel
 */
export const errorMapper = <I, E, Q, Z>(
	viewModel: AutoGeneratorForFormModel<I, E, Q>["ViewModel"],
	excludeKeys: Array<string>,
	inputModel: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
	zodSchema: Composition.ZodSchemaType<Z>,
): AutoGeneratorForFormModel<I, E, Q>["ViewModel"] => {
	const zodError = Composition.validator(inputModel, zodSchema);
	if (!zodError) return viewModel;

	// root の hasError を true にする
	viewModel.hasError = true;

	const zodIssues = zodError.issues;
	// for文で、一つ一つのエラーに対して処理を行う
	for (const issue of zodIssues) {
		const viewModelPath = ViewModelPathUtil.pathConverter(issue.path, excludeKeys);
		// エラーが発生したプロパティが除外対象の場合はスキップ
		if (viewModelPath.length === 0) continue;

		const errorObject = ViewModelPathUtil.getObjectWithViewModelPath(viewModelPath, viewModel);
		if (errorObject === undefined || errorObject === null) continue;
		if (Object.prototype.hasOwnProperty.call(errorObject, "error")) {
			// プロパティに 'error' があれば代入
			errorObject.error = issue.message;
		}

		const parentPaths = ViewModelPathUtil.getViewModelParentPaths(viewModelPath);
		for (const parentPath of parentPaths) {
			const parentObject = ViewModelPathUtil.getObjectWithViewModelPath(parentPath, viewModel);
			if (parentObject === undefined || parentObject === null) continue;
			if (Object.prototype.hasOwnProperty.call(parentObject, "hasError")) {
				// プロパティに 'hasError' があれば代入
				parentObject.hasError = true;

				if (issue.path[1] === "value") {
					// 配列に対するエラーが存在する場合は、エラーを追加する
					parentObject.error = issue.message;
				}
			}
		}
	}

	return viewModel;
};
